import { mapState } from 'vuex'
import { queryUserSubscribe } from '@/api/services/launcher-user'

export default {
  name: 'qr-code',
  data () {
    return {
      timer: null,
      value: false,
      title: '长按识别二维码关注服务号后继续浏览',
      followImg: '',
      qrcodeTime: 10 * 1000,
      delayTimer: null,
      showQr: true,
      isWidther: false,
      delayTime: 10 * 1000,
    }
  },
  computed: {
    ...mapState(['wechatUser', 'serviceConfig'])
  },
  destroyed () {
    clearTimeout(this.timer)
    clearTimeout(this.delayTimer)
  },
  async mounted() {
    const innerWidth = window.innerWidth
    if(innerWidth > 500) {
      this.isWidther = true
    }
    if (!this.serviceConfig.mustSubscribe) return

    const originid = this.serviceConfig.subscribeOriginId
    const { unionid, token } = this.wechatUser
    const params = {
      originId: originid,
      unionId: unionid,
    }
    console.log("queryUserSubscribe1", originid, '---', unionid)
    const subscribeRes = await queryUserSubscribe(params, token).catch(err => {
      console.log("获取用户订阅状态异常", err)
    })
    // 之前的wechatUser中是不包含subscribe字段的，调新的接口单独获取订阅状态，如果已经订阅了，就不再展示关注的二维码
    if(subscribeRes && subscribeRes.code === 0 && subscribeRes.result) {
      if(subscribeRes.result.subscribe === 1) {//已关注，不展示二维码
        return
      }else{//未关注，展示二维码
        this.delayTime = this.serviceConfig.delayTime ? parseInt((+this.serviceConfig.delayTime) * 1000) : 10 * 1000
        this.delayTimer = setTimeout(() => {
          this.init()
        }, this.delayTime)
      }
    }
    else{//未关注，展示二维码
      this.delayTime = this.serviceConfig.delayTime ? parseInt((+this.serviceConfig.delayTime) * 1000) : 10 * 1000
      this.delayTimer = setTimeout(() => {
        this.init()
      }, this.delayTime)
    }
  },
  methods: {
    init () {
      this.followImg = this.serviceConfig.followImg
      this.qrcodeTime = this.serviceConfig.qrcodeTime ? parseInt((+this.serviceConfig.qrcodeTime) * 1000) : 10 * 1000
      this.value = true
      this.delay(this.qrcodeTime)
    },
    delay(newVal) {
      if (!newVal) return
      this.timer = setTimeout(() => {
        this.value = false
      }, newVal)
    },
    /**
     * 暂停媒体播放
     */
    blockMedia () {
      window.mediaQueue.forEach(media => {
        if (typeof media.remove === 'function') {
          return media.remove() // 关闭视频
        }
        media.pause()
      })
    }
  }
}
